import { render, staticRenderFns } from "./LenonTextArea.vue?vue&type=template&id=697c95c1&scoped=true&"
import script from "./LenonTextArea.vue?vue&type=script&lang=js&"
export * from "./LenonTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697c95c1",
  null
  
)

export default component.exports